import { query, mutation } from '@/dex-shared/helpers/graphql';
import UEEPegasusPangareRequestService from '@/helpers/pegasus-pangare/request';

export default {
  state: {
    questions: [],
    question: {},
  },
  getters: {
    questions: (state: any) => {
      return state.questions;
    },
  },
  mutations: {
    SET_QUESTION(state: any, question: any) {
      state.question = question;
      state.question.content = question.content;
      state.question.interactiveData = question.interactiveData;
      state.question.source = question.source;
      state.question.user = question.userByUserId;

      if (question.knowledgeAssociationsByQuestionId) {
        question.knowledges = {
          formative: [],
          summative: [],
        };
        question.knowledgeAssociationsByQuestionId.nodes.map(
          (knowledgeAssociation: any) => {
            if (knowledgeAssociation.formative) {
              question.knowledges.formative.push(
                knowledgeAssociation.knowledgeByKnowledgeId,
              );
            } else if (knowledgeAssociation.summative) {
              question.knowledges.summative.push(
                knowledgeAssociation.knowledgeByKnowledgeId,
              );
            }
          },
        );
      }

      if (question.solutionsByQuestionId) {
        state.question.solutions = question.solutionsByQuestionId.nodes.map(
          (solution: any) => ({
            ...solution,
            user: solution.userByUserId,
            cachedVotesUp:
              (solution.cachedVotes && solution.cachedVotes.up) || 0,
            cachedVotesDown:
              (solution.cachedVotes && solution.cachedVotes.down) || 0,
          }),
        );
      }

      state.question.exams = [];
      if (
        question.examQuestionsByQuestionId &&
        question.examQuestionsByQuestionId.nodes.length > 0
      ) {
        state.question.exams = question.examQuestionsByQuestionId.nodes.map(
          (examQuestion: any) => {
            return examQuestion.examByExamId;
          },
        );
      }

      state.question.lists = [];
      if (
        question.listItemsByQuestionId &&
        question.listItemsByQuestionId.nodes.length > 0
      ) {
        state.question.lists = question.listItemsByQuestionId.nodes.map(
          (listItem: any) => {
            return listItem.listByListId;
          },
        );
      }

      state.question.reports = [];
      if (question.reportsByQuestionId) {
        state.question.reports = question.reportsByQuestionId.nodes;
      }
    },
    SET_EMPTY_QUESTION(state: any, mutations: any) {
      let question = {
        id: null,
        content: [
          {
            content: '',
            behavior: 'text',
          },
        ],
        answer: null,
        source: {},
        mode: 'objective',
        alternatives: 0,
        interactiveData: {
          alternatives: [
            [{ content: '', behavior: 'text' }],
            [{ content: '', behavior: 'text' }],
            [{ content: '', behavior: 'text' }],
          ],
        },
        group: null,
        solutions: [],
      };
      state.question = question;
    },
    SET_QUESTIONS(state: any, questions: any[]) {
      state.questions = questions.map((question: any) => {
        if (question.content && typeof question.content == 'string') {
          question.content = question.content;
        }
        if (
          question.interactiveData &&
          typeof question.interactiveData == 'string'
        ) {
          question.interactiveData = question.interactiveData;
        }
        return question;
      });
    },
    REMOVE_QUESTION(state: any, index: number) {
      state.questions.splice(index, 1);
    },
    REMOVE_SOLUTION_FROM_QUESTION(state: any, index: number) {
      state.question.solutions.splice(index, 1);
    },
  },
  actions: {
    async PULL_QUESTION(
      { commit, state, rootState, getters }: any,
      questionId: number,
    ) {
      const userId = rootState.auth.user.id;
      const response = await query(
        `query PullQuestion($questionId: Int!) {
                questionById(id: $questionId) {
                    id
                    content
                    answer
                    source
                    mode
                    alternatives
                    interactiveData
                    group
                    tags

                    repliesByAlternative {
                      nodes {
                        answer
                        total
                      }
                    }

                    knowledgeAssociationsByQuestionId{
                      nodes{
                        formative
                        summative
                        knowledgeByKnowledgeId {
                          id
                          name
                        }
                      }
                    }

                    solutionsByQuestionId(orderBy: CREATED_AT_ASC){
                      nodes {
                        id
                        content
                        createdAt
                        reportsBySolutionId {
                          nodes {
                            id
                            kind
                            description
                            done
                            createdAt
                          }
                        }
                        userByUserId{
                          id
                          name
                          role
                        }
                        cachedVotes {
                          up
                          down
                        }
                        updatedAt
                        validatedBy {
                          id
                          name
                          email
                        }
                        validationJudgment
                      }
                    }

                    userByUserId {
                      id
                      name
                    }

                    examQuestionsByQuestionId{
                      totalCount
                      nodes {
                        examByExamId {
                          id
                          name
                        }
                      }
                    }

                    listItemsByQuestionId{
                      totalCount
                      nodes {
                        listByListId {
                          id
                          name
                        }
                      }
                    }

                    reportsByQuestionId {
                      totalCount
                      nodes {
                        id
                        kind
                        description
                        done
                        createdAt
                      }
                    }
                  }
              }`,
        {
          questionId: +questionId,
        },
      );
      let question = response.data.questionById;
      if (question != null) {
        commit('SET_QUESTION', question);
      } else {
        commit('SET_EMPTY_QUESTION');
      }
    },

    async MERGE_QUESTIONS({ commit }: any, payload: any) {
      let response = await mutation(
        `mutation MergeQuestions($toMaintain: Int!, $toDelete: Int!) {
          mergeQuestions(input: {
            toMaintain: $toMaintain
            toDelete: $toDelete
          }) {
            questions {
              id
            }
          }
        }`,
        {
          toMaintain: +payload.toMaintain,
          toDelete: +payload.toDelete,
        },
      );
    },

    async PULL_QUESTIONS_BY_KNOWLEDGE({ commit }: any, knowledgeTag: string) {
      let response = await query(
        `query pullQuestionByKnowledge($knowledgeTag: String) {
        allKnowledges(filter:{
          name: {
            includesInsensitive: $knowledgeTag
          }
        }) {
          nodes {
            name
            knowledgeAssociationsByKnowledgeId(filter: {
              questionId: {
                isNull: false
              }
            }){
              nodes {
                questionByQuestionId{
                  id
                  content
                  examQuestionsByQuestionId{
                    totalCount
                  }
                  listItemsByQuestionId{
                    totalCount
                  }
                }
              }
            }
          }
        }
      }`,
        {
          knowledgeTag,
        },
      );
      let knowledges = response.data.allKnowledges.nodes;
      let questions: any[] = [];
      knowledges.map((knowledge: any) => {
        let knowledgeAssociations =
          knowledge.knowledgeAssociationsByKnowledgeId.nodes;
        if (knowledgeAssociations.length > 0) {
          knowledgeAssociations.map((knowledgeAssociation: any) => {
            knowledgeAssociation.questionByQuestionId.knowledge =
              knowledge.name;
            questions.push(knowledgeAssociation.questionByQuestionId);
          });
        }
      });

      commit('SET_QUESTIONS', questions);
    },

    async PULL_QUESTIONS_BY_TREE_KNOWLEDGES(
      { commit }: any,
      knowledges: Array<any>,
    ) {
      const response = await query(`
        query pullQuestionByTreeKnowledges{
          getSublevelQuestionAssociations(
            parentPaths: [
              ${knowledges.map(elem => `"${elem.nodePath}"`)}
            ]
          ){
            nodes{
              id
              content
              examQuestionsByQuestionId{
                totalCount
              }
              listItemsByQuestionId{
                totalCount
              }
            }
          }
        }
      `);
      commit(
        'SET_QUESTIONS',
        response.data.getSublevelQuestionAssociations.nodes,
      );
    },

    async PULL_QUESTIONS(
      { commit }: any,
      { currentPage, searchQuestionContent, examApplicationId }: any,
    ) {
      currentPage = currentPage || 0;
      let resultsPerPage = 50;
      let offset = resultsPerPage * currentPage;
      let response;
      let questionsNodes;
      let questionInfo = `
        id
        title
        content
        examQuestionsByQuestionId{
          totalCount
        }
        listItemsByQuestionId{
          totalCount
        }

      `;
      let filterByExamApplication = '';
      if (examApplicationId) {
        filterByExamApplication = `condition: {examApplicationId: ${examApplicationId}}`;
      }

      if (searchQuestionContent.length === 0) {
        //Simple Query
        response = await query(
          `query getAllQuestionsDexAdmin($resultsPerPage: Int, $offset: Int){
          allQuestions(
            first: $resultsPerPage,
            offset: $offset,
            orderBy: ID_DESC,
            filter: {
              draft: {
                distinctFrom: true
              }
            },
            ${filterByExamApplication}
          ) {
            nodes {
              ${questionInfo}
            }
          }
        }`,
          {
            resultsPerPage,
            offset,
          },
        );
        questionsNodes = response.data.allQuestions;
      } else {
        try {
          const response = await UEEPegasusPangareRequestService.searchDexQuestions(
            searchQuestionContent,
            resultsPerPage,
            offset,
          );

          const questionsResults =
            response && response.data && response.data.getSimilarQuestions
              ? response.data.getSimilarQuestions
              : [];

          questionsNodes = {
            nodes: questionsResults.map(q => q.questionInfo),
          };
        } catch (error) {
          console.log(`Error fetching similar questions: ${error}`);
        }
      }
      if (questionsNodes) {
        commit('SET_QUESTIONS', questionsNodes.nodes);
      }
    },

    async GET_SIMILAR_QUESTIONS(_: any, searchText: string) {
      let response = await query(
        `
          query getSimilarQuestions($searchText: String!) {
            getSimilarQuestions(searchText: $searchText) {
              id
              questionInfo {
                id
                content
              }
            }
          }
        `,
        {
          searchText,
        },
      );

      return response.data.getSimilarQuestions
        .map(q => q && q.questionInfo)
        .filter(q => q);
    },

    async REMOVE_QUESTION({ commit }: any, questionId: number) {
      try {
        await mutation(
          `mutation deleteQuestion($questionId: Int!) {
            deleteQuestionById(input:{
              id: $questionId
            }) {
              question {
                id
              }
            }
          }`,
          {
            questionId: +questionId,
          },
        );
        return true;
        //TODO call the commit directly
      } catch (err) {
        return err;
      }
    },
  },
};
